import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const ComplianceService = {
  // Get pending compliance for employee
  getAllCompliances: async () => {
    try {
      const response = await axiosInstance.get(API.compliance.getAllByEmployee);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching all compliances:", error);
      throw error;
    }
  },

  downloadPolicy: (versionId) => {
    return axiosInstance.get(`/Compliance/download`, {
      params: {
        versionId: versionId, // Make sure parameter name matches backend expectation
      },
      responseType: "blob",
      timeout: 30000, // 30 seconds timeout
      headers: {
        Accept: "application/pdf, application/octet-stream",
      },
    });
  },
  // Get policy details with versions
  getPolicyWithVersions: async (policyId) => {
    try {
      const response = await axiosInstance.get(API.compliance.getWithVersions(policyId));
      return response.data;
    } catch (error) {
      console.error("Error fetching policy details with versions:", error);
      throw error;
    }
  },

  acknowledgeCompliance: async ( acknowledgeId) => {
    try {
      const response = await axiosInstance.post(API.compliance.acknowledge, {
        acknowledgeId,
      });
      return response.data;
    } catch (error) {
      console.error("failed to acknowledge policy", error);
      throw error;
    }
  },
};

export default ComplianceService;
